import { render, staticRenderFns } from "./qualification_criteria_application_announcement_product_appendix1_4.vue?vue&type=template&id=71514006&scoped=true"
import script from "./qualification_criteria_application_announcement_product_appendix1_4.vue?vue&type=script&lang=js"
export * from "./qualification_criteria_application_announcement_product_appendix1_4.vue?vue&type=script&lang=js"
import style0 from "./qualification_criteria_application_announcement_product_appendix1_4.vue?vue&type=style&index=0&id=71514006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71514006",
  null
  
)

export default component.exports